module.exports = __webpack_public_path__ + "img/hobies.b0a79056.svg";